import { apiRequest } from "../action/api.action"
import { ADD_EXPECTED_VESSEL, ADD_EXPECTED_VESSEL_FAILURE, ADD_EXPECTED_VESSEL_SUCCESS, REMOVE_EXPECTED_VESSEL_BY_ID, REMOVE_EXPECTED_VESSEL_BY_ID_FAILURE, REMOVE_EXPECTED_VESSEL_BY_ID_SUCCESS } from "../action/expected-vessels.action";

export const expectedVesselFlow = ({ dispatch }) => next => action => {

  next(action)

  if (action.type === ADD_EXPECTED_VESSEL) {
    let url = `/api/v1/shipyards/add-expected-vessel`;
    if (action.payload.shipmanagerId) {
      url = `/api/v1/shipmanagers/${action.payload.shipmanagerId}/add-expected-vessel`;
    }
    dispatch(apiRequest('POST', url, action.payload, ADD_EXPECTED_VESSEL_SUCCESS, ADD_EXPECTED_VESSEL_FAILURE));
  }

  if (action.type === REMOVE_EXPECTED_VESSEL_BY_ID) {
    let url = `/api/v1/shipyards/remove-expected-vessel/${action.payload.id}`;
    if (action.payload.shipmanagerId) {
      url = `/api/v1/shipmanagers/${action.payload.shipmanagerId}/remove-expected-vessel/${action.payload.id}`;
    }
    dispatch(apiRequest('DELETE', url, null, REMOVE_EXPECTED_VESSEL_BY_ID_SUCCESS, REMOVE_EXPECTED_VESSEL_BY_ID_FAILURE));
  }

};

export const expectedVesselMdl = [expectedVesselFlow];